<template>
    <div>
        <breadcrumb :routerList="[{to:'/bscClueOnlineMatrixList',title:'线上矩阵列表'},{title:'线上矩阵线索'}]"/>

        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom:0.3rem">
                                    <h1>基本信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine weekplandetail14">
                                        <el-form :model="add" label-position="left" ref="bh" :inline="true"
                                                 class="demo-ruleForm h-formbLine h-formbLine1">

                                            <el-form-item label="托盘商公司名称" prop="companyName" class="h-elformWrap-2" v-if="add.taskType!=0 && add.taskType!=4">
                                                <el-input v-model="add.companyName" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="运营人员电话" prop="operatorTelephone" class="h-elformWrap-2" v-if="add.taskType!=0 && add.taskType!=4">
                                                <el-input :value="add.operator ? (add.operator + ' - ' + add.operatorTelephone) : add.operatorTelephone" readonly></el-input>
                                            </el-form-item>


                                            <el-form-item label="电商平台名称" prop="platformName" class="h-elformWrap-2">
                                                <el-input v-model="add.platformName" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="订单类型" prop="orderType" class="h-elformWrap-2">
                                                <el-input v-model="add.orderType" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="订单所在省份" prop="orderProvince" class="h-elformWrap-2">
                                                <el-input v-model="add.orderProvince" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="订单所在城市" prop="orderCity" class="h-elformWrap-2">
                                                <el-input v-model="add.orderCity" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="订单详细地址" prop="address" class="h-elformWrap-2">
                                                <el-input v-model="add.address" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="用户单位" prop="userUnitName" class="h-elformWrap-2">
                                                <el-input v-model="add.userUnitName" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="用户电话号码" prop="userPhone" class="h-elformWrap-2">
                                                <el-input v-model="add.userPhone" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="备注" prop="remark" class="h-elformWrap-2">
                                                <el-input v-model="add.remark" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="指派经销商" prop="todoPersonCode" class="h-elformWrap-2"  v-if="add.taskType==1">

                                                <el-select v-model="add.todoPersonCode" @change="salesmanChange($event)"
                                                           placeholder="指派经销商" style="width: 100%;">
                                                    <el-option
                                                        v-for="item in salesmanList"
                                                        :key="item.id"
                                                        :label="`${item.userName}(${item.userCode})`"
                                                        :value="item.userCode">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>

                                        </el-form>
                                    </div>
                                </div>
                            </div>

                            <div v-if="(add.taskType==1) && isTodoPerson(originTodoPersonCode)"
                                 class="h-txtCenter" style="margin-top: 0.3rem;">
                                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="designatecommit">确定指派</el-button>
                                <el-button class="fanhui" @click="backL">返回</el-button>
                            </div>

                            <div v-if="(add.trackStatus == '0') && isTodoPerson(originTodoPersonCode)  && (add.taskType!=1 && add.taskType!=9 && add.taskType!=11)"
                                 class="h-txtCenter" style="margin-top: 0.3rem;">
                                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="undertake(1)">承接</el-button>
                                <el-button class="h-btn h-bBtn h-bgred" v-if="add.taskType==0 || add.taskType==4" @click="undertake(3)">拒绝承接</el-button>
                                <el-button class="fanhui" @click="backL">返回</el-button>
                            </div>

                            <div v-if="(add.trackStatus == '2')  && isTodoPerson(originTodoPersonCode)"
                                 class="h-txtCenter" style="margin-top: 0.3rem;">
                                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="secondaryConfirmation">二次确认</el-button>
                                <el-button class="fanhui" @click="backL">返回</el-button>
                            </div>

                        </div>
                    </div>

                    <!-- 付款凭证（查看模式） -->
                    <div v-if="add.voucherUploadTime"  class="h-rowBox ljjtablepaddings12" style="margin-top:30px;">
                        <div class="h-rowCon" >
                            <div class="h-pieceIn2" >
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>付款凭证</h1>
                                </div>
                            </div>
                            <div class="h-pieceCon2">
                                <div class="h-formLine weekplandetail14">
                                    <brupload
                                        :refid="add.id"
                                        reftype="线上矩阵-付款凭证"
                                        :uploadflag="false"
                                        :delflag="false"
                                        :showtime="true">
                                    </brupload>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="h-rowBox ljjtablepaddings12" style="margin-top:30px;padding:0;">
                        <div class="h-rowCon" style="padding-bottom:0">
                            <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>型号明细</h1>
                                </div>
                            </div>
                            <el-table
                                ref="detailTable"
                                :data="add.detailList"
                                stripe
                                style="width: 100%"
                                :border="true">
                                <el-table-column type="index" width="50" label="#"></el-table-column>
                                <el-table-column prop="productModel" label="产品型号"></el-table-column>
                                <el-table-column prop="productCode" label="产品编码"></el-table-column>
                                <el-table-column prop="oneLevelName" label="产品大类"></el-table-column>
                                <el-table-column prop="twoLevelName" label="二级分类"></el-table-column>

                                <el-table-column prop="productNum" label="数量" width="120"></el-table-column>
                                <!--只有托盘商能看价格 -->
                                <el-table-column v-if=" (add.companyCode == _user.usercode)" prop="amount" label="金额（售卖单价）" width="180"></el-table-column>
                            </el-table>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <el-dialog :close-on-click-modal="false" :visible.sync="invalidReasonDialog" class="h-dialog2 invalid-reason-dialog">
            <div style="padding: 12px;">
                <el-form>
                    <el-form-item label="请选择原因" required>
                        <brselect placeholder="请选择原因" category="invalidReason" :v="invalidReason" v-model="invalidReason" style="width: 100%;">
                        </brselect>
                    </el-form-item>
                    <el-form-item label="其他原因" v-if="invalidReason === '其他'" required>
                        <el-input v-model="otherReason" placeholder="请输入具体原因"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div style="display:flex;justify-content:center;margin-bottom:20px">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="invalidReasonDialog = false">取消</el-button>
                <el-button class="h-btn h-bBtn h-bgblue2" @click="submitInvalidReason">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ss from "../../../api/SystemService";
import BscClueOnlineMatrix from '@/api/guanhuai/onlineMatrix/BscClueOnlineMatrix'
import _ from "loadsh";

export default {
    data() {
        return {
            id: null,
            originTodoPersonCode:'',
            invalidReasonDialog: false,
            invalidReason: '',
            otherReason: '',
            add: {
                id: '',
                companyName: '',
                companyCode: '',
                operator: '',
                operatorTelephone: '',
                platformName: '',
                orderType: '',
                bigArea: '',
                orderProvince: '',
                orderCity: '',
                address: '',
                userUnitName: '',
                remark: '',
                taskType: '',
                trackStatus: '',
                todoPersonCode: '',
                todoPersonName: '',

                detailList: [],
            },
            salesmanList: [],
        }
    },
    created() {
        this.id = this.$route.query.id;
        this.getById(this.id);
    },
    methods: {
        //当前登录人是否为承接经销商（多个编码用逗号分隔）
        isTodoPerson(code) {
            return (code || '').split(',').map(item => item.trim()).includes(this._user.usercode);
        },


        getById(id) {
            BscClueOnlineMatrix.selectById(id).then(rd => {
                this.add = rd.obj;
                this.originTodoPersonCode = rd.obj.todoPersonCode;
                if(this.add.todoPersonCode.length==8){
                    this.add.todoPersonCode ='';
                    this.add.todoPersonName ='';
                }
                if (!this.add.detailList) {
                    this.$set(this.add, 'detailList', []);
                }
                this.selectClueAgentOwner();
            })
        },

        backL() {
            this.$router.push({ path: '/bscClueOnlineMatrixList' })
        },

        salesmanChange(o) {
            if (!o) {
                this.add.todoPersonName = '';
                return;
            }
            var agent = _.find(this.salesmanList, { userCode: o });
            if (agent) {
                this.add.todoPersonName = agent.userName;
            }
        },

        selectClueAgentOwner() {
            var data = {
                "orderProvince": this.add.orderProvince,
                "orderCity": this.add.orderCity,
            }
            ss.clueAgentOwner.selectMatrixAgentOwner(data).then(res => {
                this.salesmanList = [];
                for (var i = 0; i < res.obj.length; i++) {
                    var newdata = {
                        "id": res.obj[i].agentCode,
                        "userName": res.obj[i].agentName,
                        "userCode": res.obj[i].agentCode
                    }
                    this.salesmanList.push(newdata);
                }
            })
        },

        designatecommit() {
            if (!this.add.todoPersonCode) {
                this.$message.error("未指派经销商!");
                return false;
            }

            BscClueOnlineMatrix.designate(this.add).then(res => {
                if (res.f == true) {
                    this.$msg.alerts("提交成功！", () => {
                        this.$router.push({ path: '/bscClueOnlineMatrixList' })
                    })
                } else {
                    this.$message.error(res.msg);
                }
            })
        },

        undertake(trackStatus) {
            if (trackStatus === 3) {
                this.invalidReason = '';
                this.otherReason = '';
                this.invalidReasonDialog = true;
                return;
            }
            this.$confirm(
                trackStatus === 1 ? '是否确认承接？' : '是否确认拒绝承接？',
                '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(_ => {
                    let query = {
                        id: this.id,
                        trackStatus: trackStatus,
                    }
                    BscClueOnlineMatrix.undertake(query).then(rd => {
                        if (rd.f == true) {
                            this.$msg.msgs('提交成功');
                            this.$router.push({ path: '/bscClueOnlineMatrixList' })
                        } else {
                            this.$msg.msge(rd.msg);
                        }
                    })
                })
                .catch(_ => {
                });
        },

        secondaryConfirmation() {
            this.$confirm(
                '是否确认？',
                '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(_ => {
                    let query = {
                        id: this.id,
                    }
                    BscClueOnlineMatrix.secondaryConfirmation(query).then(rd => {
                        if (rd.f == true) {
                            this.$msg.msgs('提交成功');
                            this.$router.push({ path: '/bscClueOnlineMatrixList' })
                        } else {
                            this.$msg.msge(rd.msg);
                        }
                    })
                })
                .catch(_ => {
                });
        },

        submitInvalidReason() {
            if (!this.invalidReason) {
                this.$msg.msge("请选择无效原因");
                return;
            }
            if (this.invalidReason === '其他' && !this.otherReason) {
                this.$msg.msge("请输入具体原因");
                return;
            }
            let reason = this.invalidReason === '其他' ? this.otherReason : this.invalidReason;
            let query = {
                id: this.id,
                trackStatus: 3,
                invalidReason: reason,
            }
            BscClueOnlineMatrix.undertake(query).then(rd => {
                if (rd.f == true) {
                    this.$msg.msgs('提交成功');
                    this.invalidReasonDialog = false;
                    this.$router.push({ path: '/bscClueOnlineMatrixList' })
                } else {
                    this.$msg.msge(rd.msg);
                }
            })
        },
    },
}
</script>
<style>
.weekplandetail14 .h-formbLine .el-form-item__label {
    width: 35%;
    text-align: left;
    padding-left: 40px;  /* 左对齐时标签左侧留白 */
}

.weekplandetail14 .h-formbLine .el-form-item__content {
    width: 65%;
}

.weekplandetail14 .h-formbLine .h-elformWrap-2 {
    width: 50%;
}

.weekplandetail14 .h-formbLine .h-elformWrap-1 .el-form-item__label {
    width: calc(17.5% - 0.175rem);
}
.weekplandetail14 .h-formbLine .h-elformWrap-1 .el-form-item__content {
    width: calc(82.5% + 0.175rem);
}

.ljjtablepaddings12 .h-tableInput .el-input__inner{
    padding: 0.05rem 0.1rem;
}
.ljjtablepaddings12 .h-tableInput .el-input__icon{
    line-height: 0.25rem;
}

.ljj_selectdisblednone .el-input.is-disabled .el-input__inner{
    border-color: transparent;
}
.ljj_selectdisblednone.el-select .el-input.is-disabled .el-input__inner:hover{
    border-color: transparent;
}
.ljj_selectdisblednone .el-input__suffix{
    display: none;
}

.h-view-mode .el-input__inner,
.h-view-mode .el-textarea__inner {
    background-color: #f5f7fa;
    cursor: not-allowed;
    pointer-events: none;
}
.h-view-mode .el-select .el-input__inner {
    pointer-events: none;
}
.h-view-mode .h-tableAdd {
    display: none;
}
.h-view-mode .h-tableLink {
    display: none;
}
</style>
